import { useGetBodypartsQuery } from "./bodypartsApiSlice"
import { useGetExercisetypesQuery } from "./exercisetypesApiSlice"
import NewExerciseForm from "./NewExerciseForm"
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'


const NewExercise = () => {
  useTitle('DPE: New Exercise')

  const { bodyparts } = useGetBodypartsQuery("bodypartsList", {
    selectFromResult: ({ data }) => ({
        bodyparts: data?.ids.map(id => data?.entities[id])
    }),
  })

  const { exercisetypes } = useGetExercisetypesQuery("exercisetypesList", {
      selectFromResult: ({ data }) => ({
          exercisetypes: data?.ids.map(id => data?.entities[id])
      }),
  })

  if (!bodyparts?.length || !exercisetypes?.length) return <PulseLoader color={"#5f788a"} />

  const content = <NewExerciseForm bodyparts={bodyparts} exercisetypes={exercisetypes} />
  
  return content
  
}

export default NewExercise